<!-- 饼图 -->
<style lang="stylus" scoped>
.twoWayBar {
  width: 100%;
  height: 284px;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="twoWayBar">
      <div class="main"></div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from '../common/boxWrap';
export default {
  props: ['productBar'],
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {},
      name: '扶贫产品排名',
      dataX: [],
      dataY1: [],
      dataY2: []
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    var count = 0;
    for (var i = 0; i < this.productBar.length; i++) {
      if (this.productBar[i].name && count < 3) {
        this.dataX.push(this.productBar[i].name)
        this.dataY1.push(this.productBar[i].output)
        this.dataY2.push(this.productBar[i].amount)
        count++
      }
    }
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.twoWayBar .main'));

    this.myChart.setOption({
      tooltip: {

        trigger: 'axis',
        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
          type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      legend: {
        data: ['产量', '金额'],
        top: 5,
        left: 110,
        textStyle: {
          color: '#fff',
          fontSize: 16
        }
      },
      grid: {
        top: '15%',
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'value',
          axisTick: { show: false },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#00DAEE',
            fontSize: 16
          },
          splitLine: {
            lineStyle: {
              color: '#0092EE'
            }
          }
        }
      ],
      yAxis: [
        {
          type: 'category',
          axisTick: { show: false },
          data: this.dataX,
          axisLabel: {
            color: '#00DAEE',
            fontSize: 18
          }
        }
      ],
      series: [
        {
          name: '产量',
          type: 'bar',
          barWidth: 8,
          label: {
            normal: {
              // show: true
              // position: 'inside'
            }
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#FF9E2C'
              }, {
                offset: 0.8,
                color: '#FF4E00'
              }], false)
            }
          },
          data: this.dataY1
        },
        {
          name: '金额',
          type: 'bar',
          barWidth: 8,
          stack: '总量',
          label: {
            normal: {
              // show: true
            }
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#5EB5FF'
              }, {
                offset: 0.8,
                color: '#00DAEE'
              }], false)
            }
          },
          data: this.dataY2
        }
      ]
    });
    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?7a6c3e1d